module.exports = __webpack_public_path__ + "static/media/about-us-bg.905ee1d6.png";